import React, { useState } from 'react'
import IconsTextNavigation from 'components/global/IconsTextNavigation'
import AddTemplateToLeague from '../Modals/ScheduleEmail/AddTemplateToLeague'
import { leagueEventStore } from 'state/league/leagueEvent'

const ScheduleEmail: React.FC = () => {
  const { leagueData } = leagueEventStore(store => ({
    leagueData: store.leagueData,
  }))
  const [openEmailModal, setOpenEmailModal] = useState<boolean>(false)
  return (
    <>
      <div onClick={() => setOpenEmailModal(true)}>
        <IconsTextNavigation
          iconName="EnvelopeSimple"
          heading="Scheduled emails"
          isCompleted={leagueData?.emailTemplates.length > 0 ? true : false}
        />
      </div>
      {openEmailModal && (
        <AddTemplateToLeague
          openModal={openEmailModal}
          setOpenModal={setOpenEmailModal}
        />
      )}
    </>
  )
}

export default ScheduleEmail
